module.exports = __webpack_public_path__ + "static/media/spotify2019-830x350.79e157ad.660a0554.jpg";